import { render, staticRenderFns } from "./IndexVariants.vue?vue&type=template&id=756d68c6&"
import script from "./IndexVariants.vue?vue&type=script&lang=js&"
export * from "./IndexVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports